import { SYS_BORDER_RADIUS_MD, SYS_BORDER_WIDTH_100, SYS_BLUR_BACKGROUND_300, SYS_SPACE_FIXED_200, getMargins } from '@oneaudi/unified-web-alpha-common';
import styled, { css } from 'styled-components';
import {} from './index.js';
export const StyledCard = styled.div `
  margin: ${(props) => getMargins(props.margin)};
  ${(props) => css `
    box-shadow: inset 0 0 0 ${SYS_BORDER_WIDTH_100}
      ${props.theme.sys.color.surface.interactive.card.default.stroke};
  `}
  border-radius: ${SYS_BORDER_RADIUS_MD};
  background-color: ${(props) => props.theme.sys.color.surface.interactive.card.default.fill};
  backdrop-filter: blur(${SYS_BLUR_BACKGROUND_300});

  ${(props) => props.hasPadding
    ? css `
          padding: ${SYS_SPACE_FIXED_200};
        `
    : css `
          overflow: hidden;
        `};
`;
//# sourceMappingURL=index.styles.js.map